/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ plan: NonNullable<unknown> }} Receipt_Timeline_PlanInputs */



/**
* | output |
* | --- |
* | "{plan} plan" |
*
* @param {Receipt_Timeline_PlanInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const receipt_timeline_plan = /** @type {((inputs: Receipt_Timeline_PlanInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Receipt_Timeline_PlanInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Tarif ${i?.plan}`)
	return /** @type {LocalizedString} */ (`${i?.plan} plan`)
});